import { BankAccount } from '@liveauctioneers/caterwaul-components/types/BankAccount';
import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_BANK_ACCOUNTS_REQUEST = 'LOAD_BANK_ACCOUNTS_REQUEST';
export const LOAD_BANK_ACCOUNTS_SUCCESS = 'LOAD_BANK_ACCOUNTS_SUCCESS';
export const LOAD_BANK_ACCOUNTS_FAIL = 'LOAD_BANK_ACCOUNTS_FAIL';

export const POST_BANK_ACCOUNT_REQUEST = 'POST_BANK_ACCOUNT_REQUEST';
export const POST_BANK_ACCOUNT_SUCCESS = 'POST_BANK_ACCOUNT_SUCCESS';
export const POST_BANK_ACCOUNT_FAIL = 'POST_BANK_ACCOUNT_FAIL';

export const DELETE_BANK_ACCOUNT_REQUEST = 'DELETE_BANK_ACCOUNT_REQUEST';
export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS';
export const DELETE_BANK_ACCOUNT_FAIL = 'DELETE_BANK_ACCOUNT_FAIL';

export type LOAD_BANK_ACCOUNTS_SUCCESS_ACTION = TypedActionWithPayload<typeof LOAD_BANK_ACCOUNTS_SUCCESS, BankAccount>;
export type POST_BANK_ACCOUNT_SUCCESS_ACTION = TypedActionWithPayload<typeof POST_BANK_ACCOUNT_SUCCESS, BankAccount>;
export type DELETE_BANK_ACCOUNT_SUCCESS_ACTION = TypedActionWithPayload<
    typeof DELETE_BANK_ACCOUNT_SUCCESS,
    BankAccount
>;
